import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpPaginationComponent } from './fcp-pagination.component';

@NgModule({
    declarations: [FcpPaginationComponent],
    imports: [CommonModule],
    exports: [FcpPaginationComponent]
})
export class FcpPaginationModule {}
